<!--多项填空 MBQ-->
<template>
	<div class="question-container" style="border: 1px solid #EDEFF2;">
		<div class="question-type">多项填空</div>
		<div class="title-view" :style="{ marginRight: '' }">
			<p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ `${index + 1}、` }}
				<span style="color: #4c4a56">
					{{ `${dataObj.caseProblem}` }}
				</span>
			</p>
		</div>
		<div class="question-images">
			<div v-for="(item, index) in images" :key="index" style="margin-top: 10px; position: relative">
				<img :src="item" mode="widthFix" style="width: 100%" />
			</div>
		</div>
		<div v-for="(item, index) in list" :key="index" style="margin-top: 10px;">
			<p v-if="item.text !== ''"
				style="font-size: 15px; color: #303133; font-weight: 400; word-break: break-all; width: 100%; text-align: left;">
				{{ item.text }}
			</p>
			<div class="input-container" style="border: 1px solid #EDEDED;">
				<input placeholder-class="input-placeholder" v-model="item.context" :placeholder="'请输入'"
					style="width: 100%;" />
			</div>
			<div class="question-images">
				<div class="question-images-box" @click.stop="showBigImage(imgItem, item)"
					v-for="(imgItem, imgIndex) in item.img_path" :key="imgIndex"
					style="margin-top: 10px; position: relative">
					<img :src="imgItem" mode="aspectFill" class="thumbnail-image" />
					<div class="fangda-box">查看图片</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			params: {
				type: Object,
				default: {},
			},
		},
		data() {
			return {
				dataObj: {},
				index: 0,
				list: [],
				images: [],
				value: "",
			};
		},
		watch: {
			params: {
				handler(newVal) {
					this.dataObj = newVal.data;
					this.index = newVal.index;
					this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
					this.list = JSON.parse(newVal.data.chooseList).list || [];
					this.value = newVal.data.chooseList.value || "";

					if (newVal.answer && Array.isArray(newVal.answer.answer)) {
						const answerArr = newVal.answer.answer;
						this.list.forEach(item => {
							const found = answerArr.find(ans => ans.id == item.id);
							if (found && 'context' in found) {
								item.context = found.context;
							}
						});
					}
				},
				deep: true,
				immediate: true,
			},
		},
	};
</script>

<style scoped>
	.question-logic {
		position: absolute;
		right: 13px;
		top: 28px;
		width: 13px;
		height: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewMBQ.vue